import type { FC } from 'react'

import type {
  SuggestedPrompt,
  SuggestedPromptsResult,
} from '~/hooks/useAgentSuggestedPrompts'

import { AgentResponseButton } from './AgentResponseButton'
import { MessageBubble } from './MessageBubble'

import styles from './SuggestedPrompts.module.scss'

export interface SuggestedPromptsProps {
  onSuggestedPromptClick: (prompt: SuggestedPrompt) => void
  suggestedPrompts: SuggestedPromptsResult
}

export const SuggestedPrompts: FC<SuggestedPromptsProps> = ({
  suggestedPrompts,
  onSuggestedPromptClick,
}) => (
  <div className={styles.suggestedPromptsContainer}>
    <MessageBubble sender="agent">
      <div className={styles.suggestedPromptsIntro}>
        {suggestedPrompts.introMessage}
      </div>
      <div className={styles.suggestedPromptsButtons}>
        {suggestedPrompts.prompts.map((suggestedPrompt) => (
          <div key={suggestedPrompt.id}>
            <AgentResponseButton
              onClick={() => onSuggestedPromptClick(suggestedPrompt)}
            >
              {suggestedPrompt.buttonText}
            </AgentResponseButton>
          </div>
        ))}
      </div>
    </MessageBubble>
  </div>
)

export default SuggestedPrompts
